import { JastBuilder, JqlAnonymizerVisitor } from '@atlaskit/jql-ast';

/**
 * This represents an error when trying to map a JQL AST to a collection of refinements supported by the component.
 * If the AST contains syntax or fields not supported by the filter refinement then this error will be thrown.
 */
export class UnsupportedRefinementError extends Error {
	// TODO: make non-optional when cleaning up filter_refinement_error_logging
	jql?: string;

	constructor(jql: string | undefined, message: string) {
		super(message);

		if (jql) {
			this.jql = new JastBuilder().build(jql).query?.accept(new JqlAnonymizerVisitor());
		}
	}
}
